import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatPaginatorModule } from '@angular/material/paginator';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StickyModule } from 'ng2-sticky-kit';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TagInputModule } from 'ngx-chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
//import { ExtaModule } from 'src/app/exta/exta.module';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { LandingModule } from '../landing/landing.module';
import { ExcelService } from './Services/excel.service';
import { MatTabsModule } from '@angular/material/tabs';
import { LookupBusinessUnitComponent } from './Components/lookup-business-unit/lookup-business-unit.component';
import { LookupCostCenterComponent } from './Components/lookup-cost-center/lookup-cost-center.component';
import { LookupLocationComponent } from './Components/lookup-location/lookup-location.component';
import { LookupEmployeeComponent } from './Components/lookup-employee/lookup-employee.component';
import { DialogeComponent } from './Components/dialoge/dialoge.component';
import { ErrorComponent } from './Components/error/error.component';
import { PaginatorComponent } from './Components/paginator/paginator.component';
import { HasPermissionDirective } from '../shared/Directive/permission-button.directive';
import { InvalidLinkComponent } from './Components/invalid-link/invalid-link.component';
import { BaseComponent } from './Components/base/base.component';
import { ImageLoaderDirective } from './Directive/image-loader.directive';
import { PhoneNumberFormatPipe } from './Services/phone-number-format.pipe';
import { OnPageLoaderComponent } from './Components/on-page-loader/on-page-loader.component';
import { TermsAndConditionsComponent } from './Components/terms-and-conditions/terms-and-conditions.component';
import { SyncDataPopupComponent } from './Components/sync-data-popup/sync-data-popup.component';
import { PageTinyLoaderComponent } from './Components/page-tiny-loader/page-tiny-loader.component';
import { ProfileViewComponent } from './Components/profile-view/profile-view.component';
import { MatCardModule } from '@angular/material/card';
import { AutocompleteNoDataDirective } from 'src/app/shared/Directive/autocomplete-no-data.directive';
import { PhoneNumberDirective } from './Directive/phone-number.directive';
import { CapitalizeWordsDirective } from './Directive/capitalize-words.directive';
import { DocUploadComponent } from './Components/doc-upload/doc-upload.component';
import { DocUploadListComponent } from './Components/doc-upload-list/doc-upload-list.component';
import { EmailValidatorDirective } from './Directive/email-validator.directive';
import { DirectiveZipCodeDirective } from './Directive/directive-zip-code.directive';
import { MatChipsModule } from '@angular/material/chips';
import { UploadDocumentListComponent } from './Components/upload-document-list/upload-document-list.component';
import { UploadDocumentComponent } from './Components/upload-documnt/upload-document.component';
import { TooltipPipe } from './Components/Pipe/tooltip.pipe';
import { QuestionnaireComponent } from './Components/questionnaire/questionnaire.component';


@NgModule({
  declarations: [
    LookupBusinessUnitComponent,
    LookupCostCenterComponent,
    LookupLocationComponent,
    LookupEmployeeComponent,
    DialogeComponent,
    ErrorComponent,
    PaginatorComponent,
    HasPermissionDirective,
    InvalidLinkComponent,
    BaseComponent,
    ImageLoaderDirective,
    PhoneNumberFormatPipe,
    OnPageLoaderComponent,
    TermsAndConditionsComponent,
    SyncDataPopupComponent,
    PageTinyLoaderComponent,
    ProfileViewComponent,
    AutocompleteNoDataDirective,
    PhoneNumberDirective,
    CapitalizeWordsDirective,
    DocUploadComponent,
    DocUploadListComponent,
    EmailValidatorDirective,
    DirectiveZipCodeDirective,
    UploadDocumentComponent,
    UploadDocumentListComponent,
    TooltipPipe,
    QuestionnaireComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    MatSelectModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    StickyModule,
    MatDialogModule,
    MatNativeDateModule,
    MatRadioModule,
    MatButtonModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatStepperModule,
    MatIconModule,
    MatTabsModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatInputModule,
    TagInputModule ,
    MatInputModule,
    MatCardModule,
    MatChipsModule
   ],
  exports: [PaginatorComponent,HasPermissionDirective,EmailValidatorDirective,DirectiveZipCodeDirective,
    ImageLoaderDirective,PhoneNumberFormatPipe,OnPageLoaderComponent,QuestionnaireComponent,
    PageTinyLoaderComponent,ProfileViewComponent,
    AutocompleteNoDataDirective,PhoneNumberDirective,CapitalizeWordsDirective,DocUploadComponent,DocUploadListComponent,
    UploadDocumentComponent,
    UploadDocumentListComponent,TooltipPipe

  ] ,
  providers: [ExcelService]
})
export class SharedModule { }
